export type AppRoute = 'map' | 'history' | 'settings' | 'scanner'

/** Read the current hash route (`#/`, `#/history`, `#/settings`, `#/scanner`). */
export function routeFromHash(hash = window.location.hash): AppRoute {
  const path = hash.replace(/^#\/?/, '').replace(/\/$/, '')
  if (path === 'history') return 'history'
  if (path === 'settings') return 'settings'
  if (path === 'scanner') return 'scanner'
  return 'map'
}

export function hashForRoute(route: AppRoute): string {
  if (route === 'history') return '#/history'
  if (route === 'settings') return '#/settings'
  if (route === 'scanner') return '#/scanner'
  return '#/'
}

export function navigate(route: AppRoute): void {
  const next = hashForRoute(route)
  if (window.location.hash !== next) {
    window.location.hash = next
  }
}
